/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

// Components
import ImageUploader from 'react-images-upload';

// FileSize
import fileSize from 'filesize';

// Styles
import useStyles from './imageUpload.styles';

interface ImageUploadProps {
  handleSubmit: (base64: string) => void;
}

type Props = ImageUploadProps;

const ImageUpload: React.FC<Props> = ({ handleSubmit }) => {
  const classes = useStyles();
  const [picture, setPicture] = React.useState('');

  const handleDrop = (pic: any) => {
    if (Array.isArray(pic) && pic.length === 1) {
      const reader = new FileReader();
      reader.onloadend = (e: any) => {
        const content = e.target.result;
        setPicture(content);
      };
      reader.readAsDataURL(pic[0]);
    } else {
      setPicture('');
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h4' color='primary'>
            Faça o upload de uma imagem
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.imageContainer}>
          <ImageUploader
            buttonText='Selecionar imagem'
            fileSizeError={` tamanho do arquivo é muito grande.`}
            fileTypeError={` não é uma extensão de arquivo suportada.`}
            imgExtension={['.png']}
            label={`Tamanho Máximo ${fileSize(5242880)}, somente: png`}
            maxFileSize={5242880}
            onChange={handleDrop}
            singleImage
            withIcon
            withPreview
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            color='primary'
            variant='contained'
            onClick={() => handleSubmit(picture)}>
            Enviar
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export { ImageUpload };
export default ImageUpload;
